'use client';

import React, { forwardRef } from 'react';
import { cn } from '@/components/ui/_lib/cn';
import type { UiSkeletonProps } from '@/components/ui/_lib/skeletonProps';
import { useDeferredSkeleton } from '@/components/ui/_lib/useDeferredSkeleton';
import { SkeletonLines } from '@/components/ui/_lib/SkeletonLines';
import { SKELETON_BY_COMPONENT } from '@/components/ui/_lib/skeletonRegistry';

export type FormProps = React.FormHTMLAttributes<HTMLFormElement> & { 'aria-label'?: string; 'aria-labelledby'?: string; title?: string } & UiSkeletonProps;

const sk = SKELETON_BY_COMPONENT.Form;

const Form = forwardRef<HTMLFormElement, FormProps>((props, ref) => {
  const {
    skeleton = false,
    skeletonMaxWaitMs = 2000,
    skeletonLines,
    className,
    children,
    ...domProps
  } = props;

  const showSkeleton = useDeferredSkeleton(skeleton, skeletonMaxWaitMs);

  return (
    <form       ref={ref}
      className={cn('group', 'form', className)}
      {...domProps}
    >
      <SkeletonLines show={showSkeleton} shape={sk.shape} lines={skeletonLines ?? sk.lines}>
        {children}
      </SkeletonLines>
    </form>
  );
});

Form.displayName = 'Form';

export default Form;
